import { render, staticRenderFns } from "./ShippingDocument.vue?vue&type=template&id=caa99056&scoped=true"
import script from "./ShippingDocument.vue?vue&type=script&lang=js"
export * from "./ShippingDocument.vue?vue&type=script&lang=js"
import style0 from "./ShippingDocument.vue?vue&type=style&index=0&id=caa99056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa99056",
  null
  
)

export default component.exports